import {mtop} from '../../utils';
import { message } from 'antd';

export default {
  namespace: 'personalInfo',
  state: {
    personalInfo: {
      shareholderList: [],
    },
    loanCommonInfo: {},
  },

  reducers: {
    setPersonalInfo(state, { payload: personalInfo }) {
      // 添加容错处理
      personalInfo.shareholderList ? null : personalInfo.shareholderList = [];
      return {
        ...state,
        personalInfo,
      };
    },
    setLoanCommonInfo(state, { payload: loanCommonInfo }) {
      return {
        ...state,
        loanCommonInfo,
      };
    },
  },
  effects: {
    // 获取个人信息
    * getPersonalInfo({payload}, {put, call}) {
      try {
        const response = yield call(mtop, 'register.providerinfo.get', {
          ...payload,
        });
        yield put({type: 'setPersonalInfo', payload: response});
      } catch (error) {
        message.error(error.msg);
        yield put({type: 'setPersonalInfo', payload: {}});
      }
    },
    // 获取支用贷款公用信息
    * getLoanCommonInfo({payload}, {put, call}) {
      try {
        const response = yield call(mtop, 'loan.loancommoninfo.get', {
          ...payload,
        });
        yield put({type: 'setLoanCommonInfo', payload: response});
      } catch (error) {
        message.error(error.msg);
        yield put({type: 'setLoanCommonInfo', payload: {}});
      }
    },

  },
};


// WEBPACK FOOTER //
// ./src/models/proceed/personalInfo.js